import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import UVTTipoSelect from "./UVTTipoSelect.js"

import { Label, Input, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            tipo: data.tipo,
        });
    }

    resetState() {
        this.setState({
            tipo: null,
        })
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.uvt.delete}
                postUrl={api.proyectos.config.presupuesto.uvt.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"La Unidad de Vinculación ha sido eliminada con éxito."}
                title={"Eliminar Unidad de Vinculación"}
                buttonTitle={"Eliminar Unidad de Vinculación"}
                buttonIcon={"fa fa-trash fa-lg"}

                saveButton={true}
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                buttonClass={"btn-danger"}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Unidad seleccionada</p>
                        <div className="ui-alert ui-alert-danger">
                            <i className="ti ti-trash" aria-hidden="true"></i>
                            <span>Esta acción eliminará la unidad de vinculación seleccionada.</span>
                        </div>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Nombre</Label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Tipo</Label>
                                <UVTTipoSelect disabled={true} value={this.state.tipo} onChange={(data) => this.setState({ tipo: data.pk })} />
                            </div>
                        </div>
                        <div className="ui-row-2">
                            <div className="ui-field">
                                <Label>Email</Label>
                                <Input type="text" name="email" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                            <div className="ui-field">
                                <Label>Porcentaje</Label>
                                <Input type="number" name="porcentaje" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_UVT/Delete.js